import React, { FC } from 'react';
import { LinkCont } from './Link.styles';

interface ILink {
  text: string;
  onClick: () => void;
}

const Link:FC<ILink> = ({text, onClick}) => (
  <LinkCont id="LinkCont" data-testid="linkCont" onClick={onClick}>
    {text}
  </LinkCont>
);

export default Link;